import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarPedidos/descargarPlantillaExcelPedidos`, method: 'GET', body: null, token: token})
}
